<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      label-width="80px"
    >
      <el-tree
        ref="tree"
        :data="treeData"
        :props="props"
        node-key="code"
        show-checkbox
        :default-expanded-keys="form.checkedResourceCodeList"
        :default-checked-keys="form.checkedResourceCodeList"
      />
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  getResourceTree,
  getRoleResourceTree,
  updateRoleResourceTree
} from "@/api/authorityCreate";
export default {
  name: "RolePermission",
  data() {
    return {
      props: {
        label: "realName",
        children: "child"
      },
      loading: false,
      form: {
        code: "",
        branchCode: "",
        checkedResourceCodeList: [],
        resourceCodeList: []
      },
      treeData: [],
    };
  },
  created() {},
  methods: {
    // 获取页面信息
    async getInfo(code, branchCode) {
      this.form.code = code;
      this.form.branchCode = branchCode;
      this.treeData = [];
      this.form.checkedResourceCodeList = [];
      this.form.resourceCodeList = [];
      const rLoading = this.openLoading();
      // 查询权限数
      let getTree =  new Promise (resolve => {
         getResourceTree({ branchCode: branchCode }).then(response => {
          this.treeData = response.data;
          resolve()
        });
      })
      // 查询角色权限
      let getRoleTree =  new Promise (resolve => {
        getRoleResourceTree({ code }).then(response => {
          this.form.checkedResourceCodeList = response.data;
          resolve()
        });
      })
      Promise.all([getTree,getRoleTree]).then(res=>{
        rLoading.close();
      })
    },
    // 提交
    funcSubmit() {
      // 半选的节点
      const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      // 选中的节点
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      this.form.resourceCodeList.push(...halfCheckedKeys);
      this.form.resourceCodeList.push(...checkedKeys);
      const data = this.form;
      this.loading = true;
      updateRoleResourceTree(data).then(response => {
        this.loading = false;
        this.$message({ message: response.msg, type: "success" });
        if (response.status === 0) {
          this.funcCancel();
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "permission");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
